// ponytail: noop deploy trigger 2026-07-17T13:47Z — CD full deploy (all apps)
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
